import React from 'react'
import { VisitedCrmTask } from '@/lib/hook/useVisitedCrmTasks'
import { ArgsAddPharmacyRouteToVisited } from '@/lib/hook/useVisitedPharmacyRoutes'

interface MyProfileContextInterface {
  dataMyProfile: any | null
  refetchProfile: () => Promise<any>
  dataStore: any | null
  loadingProfile: boolean
  client: any
  visitedPharmacyRoutes: any[] | null
  addPharmacyRouteToVisited: (props: ArgsAddPharmacyRouteToVisited) => void
  visitedCrmTasks: VisitedCrmTask[]
  addCrmTaskToVisited: (task: Omit<VisitedCrmTask, 'date'>) => void
  host: string
  siteBelgium: boolean
  sitePharmedischool: boolean
  siteZentiva: boolean
}

const MyProfileContext = React.createContext<MyProfileContextInterface>({
  dataMyProfile: null,
  dataStore: null,
  refetchProfile: () => null,
  loadingProfile: false,
  client: () => null,
  visitedPharmacyRoutes: null,
  addPharmacyRouteToVisited: null,
  visitedCrmTasks: [],
  addCrmTaskToVisited: null,
  host: null,
  siteBelgium: false,
  sitePharmedischool: false,
  siteZentiva: false,
})

export default MyProfileContext
